// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11iui","question":"styles_question__2ak99","description":"styles_description__2Uvt3"};